import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Icon_ThemeShowcase.png'
import _imports_1 from '../assets/Screenshot_ThemeShowcase_1.png'
import _imports_2 from '../assets/Screenshot_ThemeShowcase_2.png'
import _imports_3 from '../assets/Screenshot_ThemeShowcase_3.png'
import _imports_4 from '../assets/Screenshot_ThemeShowcase_4.png'
import _imports_5 from '../assets/Screenshot_ThemeShowcase_5.png'
import _imports_6 from '../assets/Screenshot_ThemeShowcase_6.png'
import _imports_7 from '../assets/Screenshot_ThemeShowcase_7.png'
import _imports_8 from '../assets/Screenshot_ThemeShowcase_8.png'
import _imports_9 from '../assets/Screenshot_ThemeShowcase_9.png'
import _imports_10 from '../assets/Screenshot_ThemeShowcase_10.png'
import _imports_11 from '../assets/Screenshot_ThemeShowcase_11.png'
import _imports_12 from '../assets/Screenshot_ThemeShowcase_12.png'
import _imports_13 from '../assets/Screenshot_ThemeShowcase_13.png'
import _imports_14 from '../assets/Screenshot_ThemeShowcase_14.png'
import _imports_15 from '../assets/Screenshot_ThemeShowcase_15.png'
import _imports_16 from '../assets/Screenshot_ThemeShowcase_16.png'
import _imports_17 from '../assets/Screenshot_ThemeShowcase_17.png'
import _imports_18 from '../assets/Screenshot_ThemeShowcase_18.png'


const _withScopeId = n => (_pushScopeId("data-v-aa126cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "size-appname",
  style: {"padding":"0px","margin":"0px"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "ThemeShowcase")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size-appname-icon" }, "version 1.0 (Beta)", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Changelog - 1.0 (Beta)")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Initial release")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Description")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ThemeShowcase is an app that allows you to preview all standard themes for XML layouts.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Screenshots")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scrollScreenshots" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_17,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_18,
    class: "screenshot"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Links")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://pufferrom.t.me",
  class: ""
}, "Telegram channel (releases)", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://puffercatchannel.t.me",
  class: ""
}, "Telegram channel (general)", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://puffercatrom.t.me",
  class: ""
}, "Support group", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/KZacharski/ThemeShowcase",
  class: ""
}, "GitHub repo (coming soon)", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_column = _resolveComponent("ion-column")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("ThemeShowcase")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("ThemeShowcase")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "bannerColumn" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "auto",
                    class: "description-column"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { style: {"padding":"0px","margin":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, { style: {"padding":"0px","margin":"0px"} }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.logoAndroid,
                                class: "size-appname-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://f2.puffercat.xyz/PuffercatApps/ThemeShowcase-1.0b.apk",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"},
                        download: "PufferIcons-latest.apk"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Download")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}